import { useSelector } from 'react-redux'
import Link from 'redux-first-router-link'

import { Button, Label } from 'shared/ui'

import HiddenWidget from './HiddenWidget'
import { selectContactDetailsColumnWidgetCardsByKey } from './WidgetCards/selectors'

export default function EditModeControlWindow({
  doExitEditMode,
  hiddenCards,
  doShowItem,
}) {
  const cards = useSelector(selectContactDetailsColumnWidgetCardsByKey)
  return (
    <div className="EditModeControlWindow">
      <Label className="EditModeControlWindow-title" as="div" size="large">
        Cards
      </Label>

      <div className="EditModeControlWindow-widgets">
        {hiddenCards.length === 0 && <p>All widget cards are shown.</p>}
        {hiddenCards.map(({ key }) => {
          const card = cards[key]
          if (!card) return null
          return (
            <HiddenWidget doShowItem={doShowItem} key={key} uiKey={key}>
              {card.name || card.type}
            </HiddenWidget>
          )
        })}
      </div>
      <div className="EditModeControlWindow-more">
        <Button as="div" onClick={doExitEditMode} primary size="medium">
          Done
        </Button>
        <Button
          as={Link}
          basic
          onClick={doExitEditMode}
          primary
          size="medium"
          to="/settings/integrations"
        >
          Install more integrations
        </Button>
      </div>
    </div>
  )
}
